import { forwardRef } from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import ArchiveIcon from '@mui/icons-material/Archive';
import { DeleteButton } from 'framework/ui/ui-builder';
import { Tooltip } from 'framework/ui/mui-builder';
import usePositionSlotsService from '../usePositionSlotsService';
import { POSITION_SLOT_ARCHIVE } from '../constants';

const ArchiveTooltipIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({ children, ...props }, ref) => (
  <Tooltip title="Archive position slot">
    <IconButton {...props} ref={ref}>
      {children}
    </IconButton>
  </Tooltip>
));

const buildArchiveConfirmationMessage = (employeeAlias: string | null) => {
  const irreversibleNotice =
    'This action is irreversible — the position slot cannot be reopened, only a new one can be created.';

  if (employeeAlias) {
    return `Do you really want to archive this position slot? This will unassign the employee from this position slot. ${irreversibleNotice}`;
  }

  return `Do you really want to archive this position slot? ${irreversibleNotice}`;
};

const ArchivePositionSlotButton = ({
  positionSlotId,
  employeeAlias,
  onSuccess,
}: {
  positionSlotId: string;
  employeeAlias: string | null;
  onSuccess: () => void;
}) => {
  const { archivePositionSlot } = usePositionSlotsService();

  return (
    <DeleteButton
      buttonTag={ArchiveTooltipIconButton}
      buttonText={<ArchiveIcon color="primary" sx={{ fontSize: 20 }} />}
      color="transparent"
      displayMessage={buildArchiveConfirmationMessage(employeeAlias)}
      deleteMethod={() => archivePositionSlot(positionSlotId)}
      permissionToCheck={POSITION_SLOT_ARCHIVE}
      modalConfirmButtonText="Archive"
      sx={{
        p: 0,
        minWidth: 'auto',
        width: 'auto !important',
      }}
      afterDelete={{
        successMessage: 'Position slot has been successfully archived.',
        errorMessage: 'Unable to archive the position slot.',
        execute: () => onSuccess(),
      }}
    />
  );
};

export default ArchivePositionSlotButton;
